import ModelFn from 'components/model/ModelFn'
import { useCallback } from "react"

export function useErrorHint() {
  return useCallback((err: string, title = '提示') => {
    ModelFn.confirm({
      title: '提示',
      text: err,
      noCancel: true
    })
  }, [])
}
